import {Action} from "redux";
import {IClientClientsActionCreator} from "../action/client_clients_action";
import {
    CreateClientByClientRequest,
    DeleteClientByClientRequest,
    GetAllClientsByClientRequest,
    UpdateRoleClientByClientRequest,
} from "../request/clients_request";

interface IClientClientsDispatcher {

    getAllClients(item: GetAllClientsByClientRequest): void;

    createClient(item: CreateClientByClientRequest): void;

    updateRoleClient(item: UpdateRoleClientByClientRequest): void;

    deleteClient(item: DeleteClientByClientRequest): void;
}

class Dispatcher implements IClientClientsDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientClientsActionCreator) {

    }

    public getAllClients = (item: GetAllClientsByClientRequest): void => {
        this.dispatch(this.actionCreator.requestGetAllClientsAction(item));
    };

    public createClient = (item: CreateClientByClientRequest): void => {
        this.dispatch(this.actionCreator.requestCreateClientAction(item));
    };

    public updateRoleClient = (item: UpdateRoleClientByClientRequest): void => {
        this.dispatch(this.actionCreator.requestUpdateRoleClientAction(item));
    };

    public deleteClient = (item: DeleteClientByClientRequest): void => {
        this.dispatch(this.actionCreator.requestDeleteClientAction(item));
    };
}

const createClientClientsDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientClientsActionCreator): IClientClientsDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientClientsDispatcher, createClientClientsDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_clients_dispatcher.ts